import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const AddEditBranchInfoForm = (
  strings: any,
  assigneeList: any[],
  countryList: any[],
  stateList: any[],
  cityList: any[],
  locationList: any[],
): FormModel[] => {
  return [
    {
      label: strings.sales_company_branch_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'branchName',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
    {
      label: strings.lead_management_contact_details_secondaryManager,
      value: '',
      size: 'medium',
      type: 'select',
      isMulti: true,
      isClearable: true,
      variant: 'outlined',
      placeholder: strings.lead_management_contact_details_secondaryManager,
      field: 'secondaryManagers',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 8 },
      required: true,
      options: assigneeList,
    },
    {
      label: strings.lead_management_contact_details_country,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'country',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6 },
      required: true,
      options: countryList,
    },
    {
      label: strings.customermgmt_text_state,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'state',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6 },
      required: true,
      options: stateList,
    },
    {
      label: strings.lead_management_contact_details_city,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'city',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6 },
      required: true,
      options: cityList,
    },
    {
      label: strings.parentOrg_text_location,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'location',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6 },
      required: true,
      options: locationList,
    },
    {
      label: strings.sales_company_branch_address,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'branchAddress',
      isMulti: true,
      multiline: true,
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 8, md: 8 },
      required: true,
      rows: 2,
    },
  ];
};
